import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';
import { AutomationAdd } from '@interfaces/central-monitoring';
import { AutomationTypes } from '@pages-clean/central-monitoring/dataset-hub/interfaces/hub-dataset.interface';
import { getData, postData } from '@apis/rest-client';

const AutomationApi = {
    useAdd: (studyRef: string, datasetId: number, automationType: AutomationTypes) => {
        const endpointType = automationType === AutomationTypes.Site ? 'SiteAutomations' : 'ControlsAutomations';
        return useSWRMutation(
            `CentralMonitoring/${endpointType}/${studyRef}/${datasetId}`,
            (url: string, { arg }: { arg: AutomationAdd }) => {
                return postData<AutomationAdd, number>(url, { arg, timeout: 30000 });
            },
        );
    },

    useGetStatus: (studyRef: string, isAutomationEnabled: boolean | null, automationType: AutomationTypes) => {
        let endpointUrl: string;
        switch (automationType) {
            case AutomationTypes.Controls:
                endpointUrl = `CentralMonitoring/ControlsAutomations/status/${studyRef}/${isAutomationEnabled}`;
                break;
            case AutomationTypes.Site:
            default:
                endpointUrl = `CentralMonitoring/SiteAutomations/status/${studyRef}/${isAutomationEnabled}`;
                break;
        }

        return useSWR(isAutomationEnabled !== null ? endpointUrl : null, (url: string) => {
            return getData<{ status: string; datasetName: string }>(url, { timeout: 30000 });
        });
    },

    useRun: (studyRef: string, automationType: AutomationTypes) => {
        const endpointType = automationType === AutomationTypes.Site ? 'SiteAutomations' : 'ControlsAutomations';

        return useSWRMutation(
            `CentralMonitoring/${endpointType}/run/${studyRef}`,
            (url: string, { arg }: { arg: number }) => {
                return postData<number, number>(`${url}/${arg}`, { arg, timeout: 30000 });
            },
        );
    },
    useRevert: (studyRef: string, automationId: number, automationType: AutomationTypes) => {
        const endpointType = automationType === AutomationTypes.Site ? 'SiteAutomations' : 'ControlsAutomations';

        return useSWRMutation(
            `CentralMonitoring/${endpointType}/revert/${studyRef}/${automationId}`,
            (url: string, { arg }: { arg: string }) => {
                return postData<string, boolean>(url, { arg, timeout: 30000 });
            },
        );
    },
};

export default AutomationApi;
